import { graphql, useStaticQuery } from 'gatsby'
import { ExtractProps, withTranslations } from 'hooks/useTranslations'

declare global {
  interface Snippets {
    'organisms-service-review-slider': {
      service_reviews_prev_button_title: string
      service_reviews_next_button_title: string
      service_reviews_verified_buyer: void
      service_reviews_location_de_DE: void
      service_reviews_location_nl_BE: void
      service_reviews_location_nb_NO: void
      service_reviews_location_da_DK: void
      service_reviews_location_sv_SE: void
      service_reviews_location_it_IT: void
      service_reviews_location_fr_CH: void
      service_reviews_location_pt_PT: void
      service_reviews_location_fr_BE: void
      service_reviews_location_de_CH: void
      service_reviews_location_en: void
      service_reviews_location_fr_FR: void
      service_reviews_location_de_AT: void
      service_reviews_location_es_ES: void
      service_reviews_location_hr_HR: void
      service_reviews_location_nl_NL: void
    }
  }
}

export default <C extends React.FC<ExtractProps<C>>>(Component: C) =>
  withTranslations(Component, () =>
    useStaticQuery(graphql`
      query organisms_product_reviews_translations {
        service_reviews_prev_button_title: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_prev_button_title"
        )
        service_reviews_next_button_title: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_next_button_title"
        )
        service_reviews_verified_buyer: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_verified_buyer"
        )
        service_reviews_location_de_DE: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_de_DE"
        )
        service_reviews_location_de_AT: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_de_AT"
        )
        service_reviews_location_de_CH: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_de_CH"
        )
        service_reviews_location_fr_FR: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_fr_FR"
        )
        service_reviews_location_fr_BE: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_fr_BE"
        )
        service_reviews_location_fr_CH: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_fr_CH"
        )
        service_reviews_location_en: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_en"
        )
        service_reviews_location_es_ES: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_es_ES"
        )
        service_reviews_location_da_DK: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_da_DK"
        )
        service_reviews_location_sv_SE: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_sv_SE"
        )
        service_reviews_location_nb_NO: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_nb_NO"
        )
        service_reviews_location_pt_PT: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_pt_PT"
        )
        service_reviews_location_nl_BE: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_nl_BE"
        )
        service_reviews_location_nl_NL: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_nl_NL"
        )
        service_reviews_location_it_IT: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_it_IT"
        )
        service_reviews_location_hr_HR: snippet(
          group: "organisms-service-review-slider"
          name: "service_reviews_location_hr_HR"
        )
      }
    `)
  )
